import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatTableDataSource, MatPaginator, MatSelectChange, MatSelect } from '@angular/material';
import { CIDService } from 'src/app/services/common/cid.service';
import { TranslateService } from '@ngstack/translate';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ICompany } from 'src/app/interfaces/company';
import { ErrorsService } from 'src/app/services/common/errors.service';
import * as moment from "jalali-moment";

import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { ExceptionalCoefficientsService } from 'src/app/services/http/business/ExceptionalCoefficients/exceptional-coefficients.service';
import { ExceptionalCoefficientsSearchComponent } from '../exceptional-coefficients-search/exceptional-coefficients-search.component';
import { ExceptionalCoefficientsEntryComponent } from '../exceptional-coefficients-entry/exceptional-coefficients-entry.component';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { IConfirm } from 'src/app/interfaces/confirm';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { IBranch } from 'src/app/interfaces/branch';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { BIDService } from 'src/app/services/common/bid.service';
import { environment } from 'src/environments/environment';
import { SetSessionCoefficientComponent } from '../set-session-coefficient/set-session-coefficient.component';

@Component({
  selector: 'app-exceptional-coefficients-list',
  templateUrl: './exceptional-coefficients-list.component.html',
  styleUrls: ['./exceptional-coefficients-list.component.css']
})
export class ExceptionalCoefficientsListComponent implements OnInit {

  param: any;
  errObject: any;
  isOwner: boolean;
  errors = new Array();
  pageSize: number;
  pageIndex: number;
  companyList: ICompany;
  branchList: IBranch;
  companySelected: String;
  CompanyEncryptId: string;
  filter: any;

  displayedColumns: string[] = [
    this.translate.get("label.branch"),
    this.translate.get("label.levelInfo"),
    this.translate.get("label.coursePattern"),
    this.translate.get("label.courseTime"),
    this.translate.get("label.totalCoefficient"),
    //'status',
    'function'
  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('buttonGroup') buttonToggleGroup: ElementRef;

  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    private bidService: BIDService,
    public translate: TranslateService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private exceptionalCoefficientsService: ExceptionalCoefficientsService,
    private holdingService: HoldingService,
    //private focusMonitor: FocusMonitor
  ) { }

  ngOnInit() {
    this.checkOwner()
    this.dataSource.paginator = this.paginator;
  }
  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner)
        this.getCompanyList();
      else {
        this.dataSource = null;
        this.refresh();
      }
    });
  }


  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getBranchList() {
    this.branchService.list(true).subscribe(res => {
      this.branchList = res.DataList;
    });
  }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.getBranchList();
    this.filter = null;
    this.refresh();
  }

  search() {
    this.dialog
      .open(ExceptionalCoefficientsSearchComponent, {
        width: '550px',
        data: null
      })
      .afterClosed()
      .subscribe(res => {

        this.filter = res
        this.refresh();

      });
  }

  loadCoefficients(e: MatSelectChange) {
    this.dataSource = null;
    if (this.isOwner)
      this.bidService.setBID(e.value);
    if (this.filter) {
      this.filter.BranchEncryptId = e.value;
    }
    else {
      this.filter = {
        BranchEncryptId: e.value
      }
    }
    this.refresh();
  }

  refresh() {
    this.exceptionalCoefficientsService.coefficientsList(this.filter).subscribe(res => {

      console.log(res);

      this.dataSource = res.DataList;

      this.dataSource = res.DataList.map((item) => {
        return {
          BranchEncryptId: item.BranchEncryptId,
          BranchName: item.BranchName,
          CompanyName: item.CompanyName,
          LevelInfoId: item.LevelInfoId,
          PackageName: item.PackageName,
          LevelInfoName: item.LevelInfoName,
          Id: item.Id,
          CoursePatternId: item.CoursePatternId,
          CoursePatternName: item.CoursePatternName,
          TimeStart: item.TimeStart,
          TimeEnd: item.TimeEnd,
          Coefficient: item.Coefficient,
          Status: item.Status ? this.translate.get('label.active') : this.translate.get('label.inactive'),
          CreationDate: moment.from(item.CreationDate, "en").utc(true).format(environment.dateFormat),
        }
      });


      this.paginator.length = res.Total;
      this.paginator.pageIndex = 1;
      this.paginator.pageSize = 10;
      this.pageIndex = 0;
      this.pageSize = 10;
    });
  }

  paginatorEvent(event) {

    //this.filter,
    this.exceptionalCoefficientsService.coefficientsList(this.filter, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {

        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
      });
  }


  add() {
    this.dialog.open(ExceptionalCoefficientsEntryComponent)
      .afterClosed()
      .subscribe(() => {
        this.refresh();
      });
  }

  edit(e: any) {

    this.dialog.open(ExceptionalCoefficientsEntryComponent, {
      //width: "300px",
      data: e
    })
      .afterClosed().subscribe(() => {
        this.refresh();
      });
  }

  setCoefficient(e: any) {
    this.dialog.open(SetSessionCoefficientComponent, {
      //width: "300px",
      data: e
    })
      .afterClosed().subscribe(() => {
        this.refresh();
      });
  }

  delete(data: any) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.cancel", {
        name: this.translate.get("label.coefficient")
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog.open(ConfirmComponent, {
      width: "300px",
      data: confirm
    })
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            this.exceptionalCoefficientsService.coefficientsDelete({ Id: data.Id }).subscribe(() => {

              this.snackBar.OpenSnackBar(
                this.translate.get("success.deleteCoefficient"),
                "ok",
                5000,
                SoundEnum.beep
              );
              this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
            }, () => {

              this.snackBar.OpenSnackBar(
                this.translate.get("error.deleteCoefficient"),
                "ok",
                5000,
                SoundEnum.beep
              );

            });
          }
        },
        err => {
          this.errorService.recordHasBennUsed(err);
        }
      );
  }
}
